import React, {
  useState,
  useRef,
  useContext
} from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import DoctorScheduleContext from './context';
import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import {
  showDoctorSchedule,
  editDoctorSchedule,
  createDoctorSchedule
} from '~/config/routes';
import moment from 'moment';
import { AbilityContext }   from '~/contexts/Can';

function DoctorScheduleList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(DoctorScheduleContext);
  const listEl = useRef(null);
  const ability = useContext(AbilityContext);

  const trAttr = (attr) => t(`doctor_schedules.attributes.${attr}`);

  function handleDeletionModal(id, title){
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/schedules/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Schedules')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Schedules')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'Schedules')) {
    actions.push('del');
  }
  if(ability.can('show', 'Schedules')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createDoctorSchedule}
        routeToEdit={editDoctorSchedule}
        routeToShow={showDoctorSchedule}
        listEl={listEl}
        path={'/admin/schedules/'}
        actions={actions}
        paperProps={{
          showHeader: false
        }}
        columns={[
          { title: trAttr('id'), field: 'id', type: 'numeric', precision: 0, includeThousandsSeparator: false },
          { title: trAttr('doctor'), field: 'doctor_name', type: 'string' },
          { title: trAttr('begin_date'), field: 'begin_date', type: 'datetime' },
          { title: trAttr('end_date'), field: 'end_date', type: 'datetime' },
          { title: trAttr('begin_time'), field: 'begin_time', type: 'string' },
          { title: trAttr('end_time'), field: 'end_time', type: 'string' },
          { title: trAttr('available'), field: 'is_closed', type: 'boolean' },
          // { title: trAttr('updated_at'), field: 'updated_at', type: 'datetime' },
        ]}
        context={DoctorScheduleContext}
        recordMap={
          (record) => {
            return {
              ...record,
              begin_date: record.begin_date ? moment(record.begin_date.replace('Z', '')).format('DD/MM/YYYY') : null,
              end_date: record.end_date ? moment(record.end_date.replace('Z', '')).format('DD/MM/YYYY') : null,
              begin_time: record.begin_time ? record.begin_time.split(':').slice(0, 2).join(':') : null,
              end_time: record.end_time ? record.end_time.split(':').slice(0, 2).join(':') : null,
              is_closed: record.is_closed ? false : true,
              // updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
            };
          }
        }
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(DoctorScheduleList);
